// extracted by mini-css-extract-plugin
module.exports = {"official-representative":"_93444fe79c--official-representative--2bi8R","link":"_93444fe79c--link--18pC0"};